import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gmao-spinner',
  templateUrl: './gmao-spinner.component.html',
  styleUrls: ['./gmao-spinner.component.scss']
})
export class GmaoSpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
